import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import Inbondviewtable from './inbondviewtable';
import Inbondheading from './inbondheading';
import { Search } from 'lucide-react';
import DateLabelInput from "../common/forms/DateLabelInput";
import { MdLockReset } from 'react-icons/md';

export default function Inbondview() {
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [inbondstartDate, setInbondStartDate] = useState("");
  const [inbondendDate, setInbondEndDate] = useState("");
  const [bestartDate, setBeStartDate] = useState("");
  const [beendDate, setBeEndDate] = useState("");

  useEffect(() => {
    if (location.state?.showToast) {
      toast.success(location.state.message);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  // Reset filters
  const resetFilters = () => {
    setInbondStartDate("");
    setInbondEndDate("");
    setSearchTerm("");
    setBeStartDate("");
    setBeEndDate("");
  };

  return (
    <>
      <Inbondheading />
      <div className="p-2 px-1">
        <div className="flex flex-wrap justify-center items-center gap-4 mb-4">
          {/* Search Input */}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
            <input
              type="text"
              placeholder="Search by BI No. or BE No."
              className="h-11 pl-10 pr-3 py-2 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-black"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* Date Inputs */}
          <div className='w-36'>
            <DateLabelInput
              label="In-bond Start Date"
              type="date"
              value={inbondstartDate}
              onChange={(e) => setInbondStartDate(e.target.value)}
            />
          </div>
          <div className='w-36'>
            <DateLabelInput
              label="In-bond End Date"
              type="date"
              value={inbondendDate}
              onChange={(e) => setInbondEndDate(e.target.value)}
            />
          </div>
           <div className='w-36'>
            <DateLabelInput
              label="BE Start Date"
              type="date"
              value={bestartDate}
              onChange={(e) => setBeStartDate(e.target.value)}
            />
          </div>
          <div className='w-36'>
            <DateLabelInput
              label="BE End Date"
              type="date"
              value={beendDate}
              onChange={(e) => setBeEndDate(e.target.value)}
            />
          </div>

          {/* Reset button */}
          {(inbondstartDate || inbondendDate || searchTerm || bestartDate || beendDate) && (
            <button
              onClick={resetFilters}
              className="flex items-center justify-center h-11 w-11"
              title="Reset Filters"
            >
              <MdLockReset size={20} />
            </button>
          )}
        </div>

        {/* Table */}
        <Inbondviewtable
          searchTerm={searchTerm}
          inbondstartDate={inbondstartDate}
          inbondendDate={inbondendDate}
          bestartDate={bestartDate}
          beendDate={beendDate}
        />
      </div>
    </>
  );
}
